module.exports = __webpack_public_path__ + "img/kongkong.1d2ca11e.png";